import { render, staticRenderFns } from "./guildpage.vue?vue&type=template&id=b1bce492&scoped=true&"
import script from "./guildpage.vue?vue&type=script&lang=js&"
export * from "./guildpage.vue?vue&type=script&lang=js&"
import style0 from "./guildpage.vue?vue&type=style&index=0&id=b1bce492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bce492",
  null
  
)

export default component.exports